module.exports = __webpack_public_path__ + "static/Billa-904aea2d5ba6f8565ffe2644617d682f.png";